import axiosInstance, { API_BASE } from './apiconfig';

const TOKEN_KEY = 'auth_token';
const USERNAME_KEY = 'auth_username';

export function setAuth(token, username){
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USERNAME_KEY, username);
}

export function clearAuth(){
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USERNAME_KEY);
}

export function getToken(){
  return localStorage.getItem(TOKEN_KEY);
}

export function getUsername(){
  return localStorage.getItem(USERNAME_KEY) || '';
}

export function isLoggedIn(){
  return !!getToken();
}

export async function loginApi(username, password){
  const res = await fetch(`${API_BASE}/api/accounts/login`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password })
  });
  if (!res.ok) throw new Error('Invalid credentials');
  return await res.json();
}

export async function changePasswordApi(username, oldPassword, newPassword) {
  const res = await axiosInstance.post(
    `${API_BASE}/api/accounts/changepassword`,
    {
      username,
      oldPassword,
      newPassword
    }
  );

  return res.data;
}

